<div class="header-actions" tabindex="-1" role="navigation">
  <div>
    @if (showBackButton) {
      <a se-fe-button-low (click)="back()" class="back-anchor">
        <i class="icon">
          <svg
            class="left-chevron"
            xmlns="https://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 24 24"
            preserveAspectRatio="xMidYMid meet"
            fill="currentColor">
            <path
              class="left-chevron__path"
              stroke-width="0"
              d="M15.5656854,19.4343146 C15.8781049,19.746734 15.8781049,20.253266 15.5656854,20.5656854 C15.253266,20.8781049 14.746734,20.8781049 14.4343146,20.5656854 L6.43431458,12.5656854 C6.12189514,12.253266 6.12189514,11.746734 6.43431458,11.4343146 L14.4343146,3.43431458 C14.746734,3.12189514 15.253266,3.12189514 15.5656854,3.43431458 C15.8781049,3.74673401 15.8781049,4.25326599 15.5656854,4.56568542 L8.13137085,12 L15.5656854,19.4343146 Z"></path>
          </svg>
        </i>
        <span class="label">Back</span>
      </a>
    }
  </div>
  @if (enableCart) {
    <div class="header-actions__cart-options">
      <div class="header-actions__subtotal">
        Subtotal:
        {{ cartSubtotal | currency }}
        @if (showUpfrontText) {
          <div class="header-actions__subtotal__upfront">
            if paid in full upfront
          </div>
        }
      </div>
      <se-fe-icon-button
        (click)="cartClick.emit()"
        class="cart-icon"
        [seFeDataIndicatorDot]="cartItemCount"
        seFeDataIndicatorDotColor="red"
        aria-hidden="false"
        [seFeDataButtonAttrs]="{'aria-label': 'open cart'}">
        <se-fe-icon
          aria-hidden="false"
          seFeDataName="shopping_cart"
          seFeDataSize="700"
          seFeDataColor="blue"
          title="open cart"
          tabindex="-1"
          seFeDataAriaLabel="open cart"></se-fe-icon>
      </se-fe-icon-button>
    </div>
  }
</div>
